export default __webpack_public_path__ + "static/media/Head_1_Ear_2_C5.672423b3.svg";